export const dashboardEngText = {
  daily_orders: `Daily Orders`,
  num_of_orders: `No of Orders`,
  consumption: `Consumption`,
  need: `Need`,
  date_filter: `Filter by date: `,
  total_orders: `Total Orders`,
  draft: `Draft`,
  correction_pending: `Correction Pending`,
  issued: `Issued`,
  issued_version_2: `Issued Version 2`,
  date: `Date`,
  consumption_order: `Consumption Order`,
  need_order: `Need Orders`,
  total_amount: `Total Amount`,
  orders: `Orders`,
  log_out: `Log out`,
  dashboard: `Dashboard`,
  consumption_cert: ` Consumption Certificate`,
  need_cert: `Need Certificate`,
};

export const dashboardGermText = {
  daily_orders: `Tägliche Bestellungen`,
  num_of_orders: `Anzahl der Aufträge`,
  consumption: `Verbrauchsausweis`,
  need: `Bedarfsausweis`,
  date_filter: `Nach Datum filtern: `,
  total_orders: `Aufträge insgesamt`,
  draft: `Entwurf`,
  correction_pending: `Berichtigung anhängig`,
  issued: `Ausgestellt`,
  issued_version_2: `Ausgegebene Version 2`,
  date: `Datum`,
  consumption_order: `Verbrauchsausweis`,
  need_order: `Bedarfsausweis`,
  total_amount: `Gesamtbetrag`,
  orders: `Bestellungen`,
  log_out: `Abmelden`,
  dashboard: `Dashboard`,
  consumption_cert: ` Verbrauchsbescheinigung`,
  need_cert: `Brauchen Zertifikat`,
};

export const consumptionEngText = {
  search: `Search by ID, Name, Email, Postal Code`,
  form_status: `Form Status`,
  certificate_status: `Certificate Status`,
  payment_status: `Payment Status`,
  add_services: `Add on Services`,
  Certificate: `Certificate`,
  issued_status: `Issue Status`,
  pending: `Pending`,
  Paid: `Paid`,
  Failed: "Failed",
  Draft: "Draft",
  Issued: `Issued`,
  Correction_Pending: "Correction Pending",
  Issued_Version2: "Issued Version 2",
  not_issued: `Not Issued`,
  connect: "Connect",
  dbit: "DIBt XML",
  submmited_on: `Submitted On`,
  email: "E Mail ID",
  phone_no: `Phone number`,
  Address: "Address",
  clarification: "Questions / clarification by the customer.",
  save_questions: "  Save questions",
  close: " Close",
  send_email: "Send questions by e-mail",
  appointment: "Send appointment by e-mail",
  serial_no: "Serial number",
  cert_issue: "Certificate Issued",
  reccomendation: "Recommendations for cost-effective modernization",
  component: "Components",
  Description: "Description",
  modernization: "In connection with major modernization",
  measure: "As an individual measure",
  payback: "Estimated payback period",
  add: "Add",
  generate: "Generate Final Certificate",
  Previous: "Previous",
  notes_docs: "Notes & Documents",
  save_changes: "Save changes",
  next: "Next",
  save_resume: "Save & Resume Later",
  log_out: "Log Out",
  print: "Print",
  email_id: "Email",
  resent_eamil: "Resend Email",
  shipping_company: "Shipping Company",
  tracking_no: "Tracking No",
  dispatch: "Date of Dispatch",
  save: "Save",
  send_email_order: "Send Email",
  transaction_details: "Transaction Details",
  status_email: "Email ID ",
  date: `Date `,
  method: "Payment Method ",
  transaction_id: "Transaction ID ",
  amount: "Amount ",
  amount_capture: "Amount Captured ",
};

export const consumptionGermText = {
  search: `Suche nach ID, Name, E-Mail, Postleitzahl`,
  form_status: `Formular Status`,
  certificate_status: `Zertifikat Status`,
  payment_status: `Zahlungsstatus`,
  add_services: `Zusätzliche Dienstleistungen`,
  Certificate: `Zertifikat`,
  issued_status: `Status der Ausgabe`,
  pending: `Ausstehend`,
  Paid: `Bezahlt`,
  Failed: "Gescheitert",
  Draft: "Entwurf",
  Issued: `Ausgestellt`,
  Correction_Pending: `Berichtigung anhängig`,
  Issued_Version2: `Ausgegebene Version 2`,
  not_issued: `Nicht ausgestellt`,
  connect: "verbinden",
  dbit: "DIBt XML",
  submmited_on: `Eingereicht am`,
  email: `E-Mail-ID`,
  phone_no: `Telefon`,
  Address: "Adresse",
  clarification: "Fragen / Klärung durch den Kunden.",
  save_questions: "Fragen speichern",
  close: " Schließen",
  send_email: " Fragen per E-Mail senden",
  appointment: "Termin per E-Mail senden",
  serial_no: "Seriennummer",
  cert_issue: "Ausgestelltes Zertifikat",
  reccomendation: "Empfehlungen für eine kosteneffiziente Modernisierung",
  component: "Komponenten",
  Description: "Beschreibung",
  modernization: "Im Zusammenhang mit größeren Modernisierungen",
  measure: "Als Einzelmaßnahme",
  payback: "Geschätzte Amortisationsdauer",
  add: "hinzufügen",
  generate: "Endgültiges Zertifikat generieren",
  notes_docs: "Anmerkungen & Dokumente",
  save_changes: "Änderungen speichern",
  next: "Weiter",
  save_resume: "Speichern und später fortsetzen",
  Previous: "Zurück",
  log_out: "Abmelden",
  print: "Drucken",
  email_id: "E-Mail",
  resent_eamil: "E-Mail erneut senden",
  shipping_company: "Schifffahrtsgesellschaft",
  tracking_no: "Sendungsverfolgung",
  dispatch: "Datum der Versendung",
  save: "Speichern Sie",
  send_email_order: "E-Mail senden",
  transaction_details: "Details zur Transaktion",
  status_email: "E-Mail-ID",
  date: `Datum`,
  method: "Zahlungsmethode",
  transaction_id: "Transaktions-ID",
  amount: "Betrag",
  amount_capture: "Erfasster Betrag",
};
